import { useState, useEffect } from 'react';
import { Session } from '@supabase/supabase-js';
import * as Sentry from '@sentry/react';
import { supabase } from './supabaseClient';

export function useSession() {
  const [session, setSession] = useState<Session | null>(null);

  useEffect(() => {
    supabase.auth.getSession().then(({ data }) => {
      setSession(data.session);
      if (data.session?.user) {
        Sentry.setUser({ id: data.session.user.id, email: data.session.user.email });
      }
    });
    const { data: { subscription } } = supabase.auth.onAuthStateChange(
      (_event, session) => {
        setSession(session);
        if (session?.user) {
          Sentry.setUser({ id: session.user.id, email: session.user.email });
        } else {
          Sentry.setUser(null);
        }
      }
    );
    return () => subscription.unsubscribe();
  }, []);

  return session;
}

export function useUser() {
  return useSession()?.user ?? null;
}
